import React, { Component, createRef, createContext } from "react";
import { ScrollView as NativeScrollView, Dimensions } from "react-native";

import { ANIMATION_DURATION } from "consts";
import { ScrollIndicator } from "components";

import { styles } from "./styles";

export class ScrollView extends Component {
  scrollPosition = 0;
  scroll = createRef();
  dimensions = { width: null, height: null };

  state = {
    isUpScrollIndicatorVisible: false,
    isDownScrollIndicatorVisible: false,
  };

  componentDidMount = () => {
    setTimeout(this.triggerSetIndicatorVisibility, 100);
    Dimensions.addEventListener(
      "change",
      this.setIndicatorVisibilityOnRotation,
    );
    const { width, height } = Dimensions.get("window");
    this.dimensions = { width, height };
  };

  componentDidUpdate = prevProps => {
    if (prevProps.sequence !== this.props.sequence) {
      this.resetIndicatorVisibility();
      setTimeout(this.triggerSetIndicatorVisibility, ANIMATION_DURATION / 2);
    }
  };

  componentWillUnmount = () => {
    Dimensions.removeEventListener(
      "change",
      this.setIndicatorVisibilityOnRotation,
    );
  };

  /**
   * Trigger `setIndicatorVisibility` with `onScroll`
   * If scroll is already at 0, then it would not scroll
   * Hence, we scroll to different positions, guaranteeing
   * us that `onScroll` is triggered irrespective of it's
   * starting postioning.
   */
  triggerSetIndicatorVisibility = () => {
    setTimeout(() => {
      if (this.scroll.current) {
        this.scroll.current.scrollTo({ y: 1, animated: false });
        this.scroll.current.scrollTo({ y: 0, animated: false });
      }
    }, 100);
  };

  setIndicatorVisibilityOnRotation = ({ window }) => {
    if (this.didRotate(window.width, window.height)) {
      this.resetIndicatorVisibility(this.triggerSetIndicatorVisibility);
    }
  };

  didRotate = (newWidth, newHeight) => {
    const { width, height } = this.dimensions;
    this.dimensions = { width: newWidth, height: newHeight };
    return newWidth !== width && newHeight !== height;
  };

  resetIndicatorVisibility = callback => {
    this.setState(
      {
        isDownScrollIndicatorVisible: false,
        isUpScrollIndicatorVisible: false,
      },
      callback,
    );
  };

  scrollDownBy = pixels => {
    if (this.scroll.current) {
      this.scroll.current.scrollTo({ y: this.scrollPosition + pixels });
    }
  };

  scrollToEnd = () => {
    if (this.scroll.current) {
      this.scroll.current.scrollToEnd();
    }
  };

  setIndicatorVisibility = event => {
    const {
      isDownScrollIndicatorVisible,
      isUpScrollIndicatorVisible,
    } = this.state;

    const { contentOffset, contentSize, layoutMeasurement } = event.nativeEvent;

    const indicatorMargin = 100;
    this.scrollPosition = contentOffset.y;

    const shouldUpScrollIndicatorBeVisible = contentOffset.y > indicatorMargin;
    const shouldDownScrollIndicatorBeVisible =
      this.scrollPosition + layoutMeasurement.height + indicatorMargin <
      contentSize.height;

    if (
      shouldDownScrollIndicatorBeVisible !== isDownScrollIndicatorVisible ||
      shouldUpScrollIndicatorBeVisible !== isUpScrollIndicatorVisible
    ) {
      this.setState({
        isUpScrollIndicatorVisible: shouldUpScrollIndicatorBeVisible,
        isDownScrollIndicatorVisible: shouldDownScrollIndicatorBeVisible,
      });
    }
  };

  render = () => {
    return (
      <>
        <ScrollIndicator
          icon="chevron-up"
          visible={this.state.isUpScrollIndicatorVisible}
          onPress={() => this.scroll.current.scrollTo({ y: 0 })}
        />
        <NativeScrollView
          ref={this.scroll}
          scrollEventThrottle={16}
          onScroll={this.setIndicatorVisibility}
          contentContainerStyle={styles.contentScroll}
        >
          <ScrollContext.Provider value={this.scrollDownBy}>
            {this.props.children}
          </ScrollContext.Provider>
        </NativeScrollView>
        <ScrollIndicator
          visible={this.state.isDownScrollIndicatorVisible}
          icon="chevron-down"
          onPress={() => this.scroll.current.scrollToEnd()}
        />
      </>
    );
  };
}

export const ScrollContext = createContext(null);
